/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconPerson/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconPerson({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconPerson",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconPerson.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1qMpSu': alignSelf,'--mt-2-1qMpSu': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1qMpSu': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1qMpSu': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1qMpSu': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1qMpSu': opacity,'--w-10-1qMpSu': typeof width === 'number' ? `${width}px` : width,'--h-11-1qMpSu': typeof height === 'number' ? `${height}px` : height,'--a-7-1qMpSu': isAnimated ? animation : "none",'--sd-8-1qMpSu': isAnimated ? strokeDashoffset : 0,'--sd-9-1qMpSu': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconPerson.SvgPath"
  data-view-path={viewPath}
 d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
 style={{'--f-12-1qMpSu': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}